define('app/sds/menu/md/sidenav/items/sds-menu-md-sidenav-items',["service!selcomm", "$rootScope", "$timeout", "$compile", "$location", "template!sds-menu-md-sidenav-items-default-transclude", "template!sds-menu-md-sidenav-items-recurse"], function (SelcommWS, $rootScope, $timeout, $compile, $location, defaultTranscludeTemplate) {
	"use strict";
	var i = 0;
	return {
		// Require specifies controllers to look for
		// These will be bound to your controller on PostLink (After the constructor)
		require: {},
		transclude: true,
		controller: {
			// Bind attributes here
			bind: {
				"menuItems": "=?",
				"selected": "=?",
				"attrs": "=?",
				"_owner": "&?owner",
				"rootName": "@?rootName",
				"_isLoading": "=?isLoading",
				"loadMenuItems": "&?"
			},
			defaults: {
				"_owner": angular.noop,
				"loadMenuItems": angular.noop
			},
			// Define functions here and default properties that are simple types (not objects or arrays)
			prototype: {
				getSelfAndParents: function getSelfAndParents() {
					var arr = [], current = this;
					while (current) {
						arr.unshift(current);
						current = current.owner;
					}
					return arr;
				},
				reset: function () {
					this.selected = null;
				}
			},
			// Define properties with getter/setters
			properties: {
				owner: function () {
					return angular.isFunction(this._owner) ? this._owner() : undefined;
				}
			},
			// Define the constructor, the parameters here are injected, you must use injection to get any of the following
			// $scope, $element, $attrs, $transclude
			// Also note that controllers from the require property will not exist at this stage and are only added after linking
			constructor: ["$scope", "$element", "$attrs", "$transclude", "$self", "$watch", function ($scope, $element, $attrs, $transclude, vm, $watch) {
				vm.transcludeTo = function transcludeTo(target, menuItem) {
					$transclude($scope.$new(), function (clone, scope) {
						
						target.element.empty();
						if (clone.length) {
							target.element.append(clone);
						}
						else {
							scope.$menuItem = menuItem;
							$compile(defaultTranscludeTemplate)(scope, function (clone, scope) {
								target.element.append(clone);
							});
						}
					});
				};
			}]
		},
		link: ["$scope", "$element", "$attrs", "$controllers", "$transclude", "$self", "$parent", function ($scope, $element, $attrs, $controllers, $transclude, vm, $parent) {
			if (!("menuItems" in $attrs) && $parent) {
				Object.defineProperties(vm, {
					loading: {
						get: function loading_get() {
							if ($parent.selected) {
								return $parent.selected.loadingChildMenuItems;
							}
							else {
								return undefined;
							}
						}
					},
					menuItems: {
						get: function menuItems_get() {
							if ($parent.selected) {
								return $parent.selected.ChildMenuItems;
							}
							else {
								return undefined;
							}
						}
					}
				});
				if (angular.isFunction($parent.loadChildMenuItems)) {
					$parent.loadChildMenuItems();
				}
				vm.useRouting = false;
			}
			else {
				vm.loadMenuItems();
				Object.defineProperties(vm, {
					loading: function loading_get() {
						return this._isLoading;
					}
				});
			}
			vm.selfAndParents = vm.getSelfAndParents();
		}]
	}
});
